import { useFilterEmployeeDiciplinaryContext } from "./filter-employee-diciplinary.context";

export function FilterEmployeeDiciplinary() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmployeeDiciplinaryContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}